var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"option-selection-box"},[_c('span',{staticClass:"value",class:{ 'has-option': _vm.option },domProps:{"innerHTML":_vm._s(_vm.value)}}),_c('i',{staticClass:"material-icons"},[_vm._v("expand_more")])])
}
var staticRenderFns = []

export { render, staticRenderFns }